import leaveByUrl, { NAMESPACE_TYPES } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/namespaces/leave_by_url.js?vue3';
import { initGroupsShowApp } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/groups/show/index.js?vue3';
import { initGroupReadme } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/groups/init_group_readme.js?vue3';
import initReadMore from '~/read_more';
import { initGroupActions } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/groups/show/actions/index.js?vue3';
import { addShortcutsExtension } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/behaviors/shortcuts/index.js?vue3';
import ShortcutsNavigation from '~/behaviors/shortcuts/shortcuts_navigation';
import initNotificationsDropdown from '/builds/gitlab/gitlab-ee/app/assets/javascripts/notifications/index.js?vue3';

addShortcutsExtension(ShortcutsNavigation);
initNotificationsDropdown();
initGroupsShowApp();
initReadMore();
initGroupReadme();
initGroupActions();
leaveByUrl(NAMESPACE_TYPES.GROUP);
